// store/index.ts
import { createPinia, defineStore } from 'pinia';
import { useLoadingStore } from "@/stores/loading";
import { useAuthStore } from '@/stores/auth';
import { useUserStore } from '@/stores/user';
import { useUserFilesStore } from '@/stores/userFiles';
import { useLegalStore } from '@/stores/legal';
import { useProfileStore } from '@/stores/profile';
import { useNetworksStore } from '@/stores/networks';
import { useRatingStore } from '@/stores/ratings';
import { useRecommendationStore } from '@/stores/recommendations';
import { useEventsStore } from '@/stores/events';
import { useApplicationsStore } from '@/stores/applications';
import { useAssignmentsStore } from '@/stores/assignments';
import { useFavoritesStore} from "@/stores/favorites";
import { useDashboardStore } from './dashboard';
import { useLandingStore } from './landing';

const pinia = createPinia();

export {
    pinia,
    useLoadingStore,
    useAuthStore,
    useUserStore,
    useUserFilesStore,
    useLegalStore,
    useProfileStore,
    useNetworksStore,
    useRatingStore,
    useRecommendationStore,
    useEventsStore,
    useApplicationsStore,
    useAssignmentsStore,
    useFavoritesStore,
    useDashboardStore,
    useLandingStore
};

import api from '@/api/api';
